<script>
import BlockingContainer from '@components/BlockingContainer';
import editFormChange from '@mixins/editFormChange';
import CountryModel from '@models/Country';
import isFunction from 'lodash/isFunction';

export default {
  components: {
    BlockingContainer,
  },
  mixins: [editFormChange],
  props: {
    // eslint-disable-next-line
    loadedId: {
      default: null,
    },
  },
  data() {
    return {
      country: {
        name: null,
        name_de: null,
        iso_2_code: null,
        order: null,
      },
    };
  },
  mounted() {
    if (this.loadedId) {
      this.$wait.start('country loading');
      CountryModel.find(this.loadedId).then((response) => {
        this.country = Object.assign({}, this.country, response.country);
        this.$wait.end('country loading');
        this.$nextTick(() => {
          this.initChangeWatcher(['country'], this.validate);
        });
      });
    }
  },
  methods: {
    validate(callback) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$wait.start('country loading');
          this.submit(callback);
        }
      });
    },
    submit(callback) {
      if (this.$route.params.id) {
        this.country.id = this.$route.params.id;
      }
      new CountryModel(this.country)
        .save()
        .then((response) => {
          this.$emit('submitted', response.country);
          if (callback && isFunction(callback)) callback();
          this.$wait.end('country loading');
        })
        .catch(() => this.$wait.end('country loading'));
    },
  },
};
</script>

<template>
  <div>
    <BlockingContainer v-if="$wait.is('country loading')"></BlockingContainer>
    <b-form @submit.prevent="validate">
      <b-form-group>
        <template v-slot:label class="col-form-legend col-12">
          {{ $t('fields.name') }}:
          <span class="status-star text-danger">*</span>
        </template>
        <b-form-input
          id="name"
          v-model="country.name"
          v-validate="'required|max:255'"
          data-vv-value-path="localValue"
          data-vv-name="name"
          :data-vv-as="$t('fields.name')"
          type="text"
          :state="errors.has('name') ? false : null"
          aria-describedby="input-feedback-name"
          :placeholder="$t('placeholders.name')"
        >
        </b-form-input>

        <b-form-invalid-feedback id="input-feedback-name">
          <template v-show="errors.has('name')">{{ errors.first('name') }}</template>
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <template v-slot:label class="col-form-legend col-12">
          {{ $t('fields.name_de') }}:
          <span class="status-star text-danger">*</span>
        </template>
        <b-form-input
          id="name_de"
          v-model="country.name_de"
          v-validate="'required|max:255'"
          data-vv-value-path="localValue"
          data-vv-name="name_de"
          :data-vv-as="$t('fields.name_de')"
          type="text"
          :state="errors.has('name_de') ? false : null"
          aria-describedby="input-feedback-name_de"
          :placeholder="$t('placeholders.name_de')"
        >
        </b-form-input>

        <b-form-invalid-feedback id="input-feedback-name_de">
          <template v-show="errors.has('name_de')">{{ errors.first('name_de') }}</template>
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <template v-slot:label class="col-form-legend col-12">
          {{ $t('fields.iso_2_code') }}:
          <span class="status-star text-danger">*</span>
        </template>
        <b-form-input
          id="iso_2_code"
          v-model="country.iso_2_code"
          v-validate="'required|max:2'"
          data-vv-value-path="localValue"
          data-vv-name="iso_2_code"
          :data-vv-as="$t('fields.iso_2_code')"
          type="text"
          :state="errors.has('iso_2_code') ? false : null"
          aria-describedby="input-feedback-iso_2_code"
          :placeholder="$t('placeholders.iso_2_code')"
        >
        </b-form-input>

        <b-form-invalid-feedback id="input-feedback-iso_2_code">
          <template v-show="errors.has('iso_2_code')">{{ errors.first('iso_2_code') }}</template>
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <template v-slot:label class="col-form-legend col-12"> {{ $t('fields.order') }}: </template>
        <b-form-input
          id="order"
          v-model="country.order"
          v-validate="''"
          data-vv-value-path="localValue"
          data-vv-name="order"
          :data-vv-as="$t('fields.order')"
          type="text"
          :state="errors.has('order') ? false : null"
          aria-describedby="input-feedback-order"
          :placeholder="$t('placeholders.order')"
        >
        </b-form-input>

        <b-form-invalid-feedback id="input-feedback-order">
          <template v-show="errors.has('order')">{{ errors.first('order') }}</template>
        </b-form-invalid-feedback>
      </b-form-group>
      <b-button type="submit" :disabled="errors.any()" :variant="'outline-' + (!errors.any() ? 'dark' : 'danger')">
        {{ $t('actions.submit') }}
      </b-button>
    </b-form>
  </div>
</template>
